import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Container, Image } from 'react-bootstrap';
import 'components/navbar/navbar.scss';
import { LocaleContext } from 'routes/Router';
import 'assets/styles/common.scss';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileData } from 'store/AdminProfile/AdminProfileAction';
import { getEnterpriseProfileCallAPI } from 'store/EnterpriseAdmin/enterpriseProfile/action';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import CommonToast from 'components/commom/CommonToast';

const CustomNavbar = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [profileValue, setProfileValue] = useState('');

  const adminProfileReducer = useSelector(
    (state) => state?.profileDataReducer?.loading
  );
  const enterpriseProfileLoader = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.loading
  );

  useEffect(() => {
    profileData();
  }, []);

  const profileData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProfileValue(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const userRole = getUserRole();
    if (userRole === 'enterprise-admin') {
      dispatch(getEnterpriseProfileCallAPI(external));
    } else {
      dispatch(getProfileData(external));
    }
  };

  return (
    <Navbar className={`d-flex ${locale === 'en' ? 'navbarEn' : 'navbarAr'}`}>
      <Container fluid>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <div
          className={`d-flex ${locale === 'en' ? 'ml-auto' : 'mr-auto'} items-center`}
        >
          <div
            className={`d-flex align-items-center ${locale === 'en' ? 'ms-4' : 'me-4'}`}
          >
            <Avatar
              className={locale === 'en' ? 'me-3' : 'ms-3'}
              style={{
                cursor: 'pointer',
                backgroundColor: '#D8E3FF',
                color: '#4573B9',
              }}
            >
              {profileValue?.profile_image !== '' ? (
                adminProfileReducer || enterpriseProfileLoader ? (
                  <Shimmer width="88px" height="88px" borderRadius="50%" />
                ) : (
                  <Image src={profileValue?.profile_image} alt="icon" />
                )
              ) : (
                profileValue?.full_name
                  ?.split(' ')
                  .map((word) => word[0])
                  .join('')
                  .toUpperCase()
              )}
            </Avatar>
            <p
              className={`p-0 m-0 fs-14 fc-404040 family_outfit_semiBold_600 ${locale === 'en' ? 'me-4' : 'ms-4'}`}
            >
              {adminProfileReducer || enterpriseProfileLoader ? (
                <Shimmer width="80px" height="20px" />
              ) : (
                profileValue?.full_name
              )}
            </p>
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
